export const theme = {
  container: {
    maxWidth: '960px',
    margin: '0 auto',
    padding: '24px 20px',
    fontFamily: "'DM Sans', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
    color: '#1a1a2e',
    minHeight: '100vh',
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 24px rgba(0,0,0,0.04)',
    padding: '24px',
    marginBottom: '16px',
    border: '1px solid rgba(0,0,0,0.06)',
    transition: 'box-shadow 0.2s ease',
  },
  title: {
    fontSize: '1.35rem',
    fontWeight: '700',
    marginBottom: '1rem',
    color: '#1a1a2e',
    letterSpacing: '-0.3px',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    fontSize: '0.92rem',
    borderRadius: '10px',
    border: '1.5px solid #e2e4e9',
    marginBottom: '12px',
    outline: 'none',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    boxSizing: 'border-box',
    background: '#fafbfc',
    color: '#1a1a2e',
  },
  button: {
    background: '#1a1a2e',
    color: '#fff',
    padding: '10px 22px',
    borderRadius: '10px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '600',
    marginTop: '6px',
    transition: 'all 0.15s ease',
    letterSpacing: '0.1px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  listItem: {
    padding: '14px 16px',
    borderRadius: '12px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'background 0.15s ease',
    marginBottom: '2px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  badge: {
    fontSize: '0.75rem',
    background: '#f0f1f4',
    padding: '3px 10px',
    borderRadius: '20px',
    color: '#5a5d6e',
    fontWeight: '600',
    letterSpacing: '0.2px',
  },
};